export default __webpack_public_path__ + "static/media/close-tipo-busqueda-modal.7cfc39af.svg";